import { combineReducers } from '@reduxjs/toolkit';
import { informationReducer, InformationState } from './information/reducers';
import { dependentsReducer, DependentsState } from './dependents/reducers';

export type ConsumerState = {
  information: InformationState;
  dependents: DependentsState;
};

export const consumerReducer = combineReducers({
  information: informationReducer,
  dependents: dependentsReducer
});
